module.exports = __webpack_public_path__ + "img/login-bg.5fb1883c.png";